var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showMessage)?_c('section',{staticClass:"study-not-found d-flex align-center justify-center flex-column"},[_c('h1',[_vm._v("Not Found")]),_c('p',[_vm._v(" The study you're trying to access is not found. ")])]):_c('v-progress-linear',{attrs:{"indeterminate":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }